import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import OurApps from './pages/OurApps'
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import SollaiSolPrivacy from './pages/SollaiSolPrivacy';
import AppRedirectPage from './pages/AppRedirectPage';
import NotFound from './pages/NotFound'
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/ourapps" element={<OurApps />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/privacy" element={<SollaiSolPrivacy />} />
            <Route path="/app/:appSlug" element={<AppRedirectPage />} />
            <Route path="*" element={<NotFound/>}/>
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
